import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfDialogHeader, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LIQUIDITY_NEED_DETAILS_DEFAULT_VISIBLE_COLUMNS, LIQUIDITY_NEED_DETAILS_MIN_VISIBLE_COLUMNS } from '../../config/constants';
import type { ILiquidityCalculationValues } from '../../interfaces';
import { LiquidityNeedDetailsGraph } from './liquidity-need-details-graph';
import { LiquidityNeedDetailsZoomSlider } from './liquidity-need-details-zoom-slider';

interface ILiquidityNeedDetailsModalProps {
    show: boolean;
    calculationData: ILiquidityCalculationValues;
    onClose: () => void;
    onEditLiquidityNeed: () => void;
}

export const LiquidityNeedDetailsModal: FunctionComponent<ILiquidityNeedDetailsModalProps> = ({ show, calculationData, onClose, onEditLiquidityNeed }) => {
    const { t } = useTranslation();

    const totalColumns = calculationData.needCalculationSteps.length;
    const [visibleColumns, setVisibleColumns] = useState(Math.min(LIQUIDITY_NEED_DETAILS_DEFAULT_VISIBLE_COLUMNS, totalColumns));

    return (
        <ZfDialog show={show} onDialogClose={onClose} size="large" position="center">
            <ZfDialogHeader>{t('liquidityNeedDetailsModal.title')}</ZfDialogHeader>
            <ZfDialogContent>
                <div style={{ width: '100%', height: 'calc(50vh - 2 * var(--padding-vertical-xl))' }}>
                    {show && <LiquidityNeedDetailsGraph key={visibleColumns} calculationData={calculationData} visibleColumns={visibleColumns} />}
                </div>
            </ZfDialogContent>
            <ZfDialogFooter>
                {totalColumns > LIQUIDITY_NEED_DETAILS_MIN_VISIBLE_COLUMNS && (
                    <LiquidityNeedDetailsZoomSlider totalColumns={totalColumns} visibleColumns={visibleColumns} setVisibleColumns={setVisibleColumns} />
                )}
                <ZfTextButton slot="primary" size="medium" hierarchy="primary" onClick={onEditLiquidityNeed}>
                    {t('liquidityNeedDetailsModal.editButton')}
                </ZfTextButton>
            </ZfDialogFooter>
        </ZfDialog>
    );
};
